import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';

import { DateFormatter2 } from '../Common/dateFormat';
import { roundTo, roundToDecimals } from '../Common/NumberUtil';
import { isJML } from '../../actions/root_url';

const { Selectors } = Data;

export class MultiBatchModal2 extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      selectedRows: null,
      editedRows: [],
      filters: {},
      quantityRemaining: 0,
    }
  }

  componentDidMount() {
    if (this.props.batchesInfo) {
      this.initializeModal(this.props.batchesInfo.batches);
      this.setState({quantityRemaining: this.props.quantityValue});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.quantityValue) {
      this.setState({quantityRemaining: Number(nextProps.quantityValue)});      
    }
    if (this.props.batchesInfo.batches !== nextProps.batchesInfo.batches) {
      this.initializeModal(nextProps.batchesInfo.batches);
    }
  }

  initializeModal = (array) => {
    let index = 0;
    let formatter = [];
    if (array && array.length > 0) {
      array.map((r) => {
        formatter.push({
          Idx: index++,
          batchId: r.id,
          quantity: "0",
          expire_datetime: r.expire_datetime,
          batch_num: r.batch_num,
          pallet_barcode: r.pallet_barcode,
          location: r.location,
          availableQty: isJML ? r.box : r.quantity,
          pcs: isJML ? r.pcs : 0,
        });
      })
    } else {
      formatter.push({
        Idx: 0,
        batchId: null,
        quantity: "0",
        expire_datetime: null,
        batch_num: null,
        location: null,
        pallet_barcode: null,
        availableQty: null
      });
    }
    this.setState({
      rows: formatter,
      selectedRows: [],
      editedRows: [],
    });
  }

  handleOnSubmit = (e) => {
    const {
      rows,
    } = this.state;
    
    // get the selected line
    const selected = this.props.lineBatchRows.filter(
      item => item.Index === this.props.lineBatchIdx
    );
    // this.props.onEditBatch(this.props.lineBatchRows);
    this.props.onSelectedMultiBatch(selected.length >= 1 ? selected[0] : [], rows);
  };

  onClickAddAll(idx) {
    let {rows, quantityRemaining} = this.state;
    rows.map((r, index)=>{
      if (r.Idx === idx) {
        quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
        if ( r.availableQty <= quantityRemaining) {
          if(isJML && r.availableQty <= 0 && this.props.selectedInventoryRow.IsOverSaleable) {
            rows[index].quantity =  Number(quantityRemaining);
            quantityRemaining = 0;
          } else {
            rows[index].quantity = r.availableQty;
            quantityRemaining = Number(quantityRemaining) - Number(r.availableQty);
          }
        } else {
          rows[index].quantity = quantityRemaining;
          quantityRemaining = 0;
        }
      }
    });
    this.setState({rows, quantityRemaining});
  }

  onClickRemoveAll(idx) {
    let {rows, quantityRemaining} = this.state;
    rows.map((r, index)=>{
      if (r.Idx === idx) {
        quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
        rows[index].quantity = 0;
      }
    });
    this.setState({rows, quantityRemaining});
  }

  renderAgentTable() {
    const getRows = () => {
      return Selectors.getRows(this.state);
    }
    const getSize = () => {
      return getRows().length;
    }
    const rowGetter = rowIdx => {
      var rows = getRows();
      return rows[rowIdx];
    }

    const handleRowUpdated = e => {
      this.setState({ sortColumn: null, sortDirection: null })
      let { quantityRemaining } = this.state;
      let rows = getRows();
      let editedRows = this.state.editedRows.slice(0);
      
      if (e.updated && e.updated.quantity > rows[e.rowIdx].availableQty && (!isJML || isJML && !this.props.selectedInventoryRow.IsOverSaleable)) {
        alert("Cannot exceed available quantity.");
        return;
      } else if ((Number(e.updated.quantity) < Number(rows[e.rowIdx].quantity))) {
        this.setState({quantityRemaining: Number(quantityRemaining)+Number(rows[e.rowIdx].quantity)-Number(e.updated.quantity)});
      } else if (e.updated && Number(e.updated.quantity) > Number(quantityRemaining)) {
        alert("Cannot exceed remaining quantity.");
        return;
      } else if ((Number(e.updated.quantity) !== Number(rows[e.rowIdx].quantity))) {
        this.setState({quantityRemaining: Number(quantityRemaining)+Number(rows[e.rowIdx].quantity)-Number(e.updated.quantity)});
      }

      Object.assign(rows[e.rowIdx], e.updated);
      editedRows.forEach((element, index) => {
        if (element.Idx === rows[e.rowIdx].Idx) { editedRows.splice(index, 1); }
      }, this);
      editedRows.push(rows[e.rowIdx]);
      this.setState({
        rows: rows,
        editedRows: editedRows,
      });
    }
      
    const onRowsSelected = (rows) => {
      let newRows = getRows();
      let selectedRows = [...this.state.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = true;
        selectedRows.push(r.row);
      });
      this.setState({ rows: newRows, selectedRows });
    }
    
    const onRowsDeselected = (rows) => {
      let newRows = [...this.state.rows];
      let selectedRows = [...this.state.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = selectedRows.indexOf(r.row);
        selectedRows.splice(rowIndex, 1);
      });
      this.setState({ rows: newRows, selectedRows });
    }

    const columns = [
      {
        key: 'Idx',
        name: <Translate value="operation" />,
        resizable: true,
        width: 100,
        formatter: ({ value, dependentValues }) => (
          <div
          style={{width: '100%'}}
          >
            <span onClick={() => {
              this.onClickAddAll(value);
            }}
            style={{cursor: "pointer", color: "green", marginRight: '12px'}}
          >+All</span>
          <span onClick={() => {
              this.onClickRemoveAll(value);
            }}
            style={{cursor: "pointer", color: "red"}}
          >-All</span>
          </div>
        ),
        width: 100,
        getRowMetaData: (row) => row,
      },
      {
        key: 'quantity',
        name: <Translate value="quantity" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 90,
      },
      {
        key: 'location',
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'availableQty',
        name: <Translate value="available" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      ...isJML ? [
        {
          key: 'pcs',
          name: <Translate value="pc_box" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
      ]:[],
      {
        key: 'pallet_barcode',
        name: <Translate value="plt_barcode" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
        formatter: DateFormatter2,
      },
      {
        key: 'batch_num',
        name: <Translate value="batch_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
    ]

    return (
      <Row>
        <label style={{color: 'orange', fontSize: '15px'}}>Quantity Remaining: {this.state.quantityRemaining}</label>
        <Col>
          <div style={{ maxWidth: isJML ? '600px' : '550px', marginLeft: '25px' }}>
            <ReactDataGrid
              enableCellSelect={true}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={300}
              rowHeight={25}
              headerRowHeight={45}
              onRowUpdated={handleRowUpdated}
            />
          </div>
        </Col>
      </Row>
    )
  }

  render() {
    const {
      setModalVisibility,
      isVisible,
    } = this.props;
    const {
    } = this.state;

    return (
      <div>
        <Row>
          <Col className="text-center">
            <span>{this.renderAgentTable()}</span>
          </Col>
        </Row>

        <Row className="centerStyle" style={{ marginTop: '20px' }}>
          <Button
            style={{ marginRight: '5px' }}
            bsStyle="success"
            onClick={(e) => { this.handleOnSubmit(e); }}
          >
            <Translate value="add_batches" />
          </Button>
        </Row>
      </div>
    );
  }
}

export default MultiBatchModal2;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/MultiBatchModal2.jsx